import { Http, RequestOptions, Headers } from '@angular/http';
import { AuthService, User } from './../user/auth.service';
import { Subject } from 'rxjs/Subject';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RegistryService } from '../registry/registry.service';
import { ConfigurationService } from '../shared/configuration.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Registry } from '../registry/registry';
import { Settings } from '../settings/settings';
import { ToastType } from '../toast/toast.enum';
import { environment } from '../../environments/environment';
import { Contribution } from '../track/contribution';
import { Gift } from '../gift/gift';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Route } from '@angular/compiler/src/core';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Website } from '../website-builder/wedding';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-account-share',
  templateUrl: './account-share.component.html',
  styleUrls: ['./account-share.component.scss']
})
export class AccountShareComponent implements OnInit {
  isConnected: boolean;
  registry: Registry;
  isLoaded = false;
  processing = false;
  isVerified: boolean;
  stripeAccountId: string;
  baseUrl: string;
  dupeStripeAccount = false;
  coppied = false;
  isLive: boolean;
  copyLabel = "Copy";
  stripeClientId: string;
  qrImageSrc = null;
  settings: Settings;
  user: User;
  payoutsEnabled = undefined;
  showPopup = false;
  gifts: Gift[];
  private ngUnsubscribe: Subject<void> = new Subject();
  website: Website;
  isLoading: boolean = true;
  showPassword: boolean;
  passwordChanged: boolean;


  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _configuration: ConfigurationService,
    private _analyticsService: AnalyticsService,
    private _authService: AuthService,
    private _http: Http,
    private _registryService: RegistryService,
    private _websiteStateStore: WebsiteStateStore,
    private route: ActivatedRoute,
    private _router: Router
  ) {


    this._authService.user.takeUntil(this.ngUnsubscribe).subscribe(user => {
      this.user = user;
      this._registryFirebaseService.initGiftsForUser(user);
    });



    this.baseUrl = this._configuration.baseUrl;
    this.stripeClientId = this._configuration.stripeClientId;

    this.loadForm();
    this.copyLabel = "Copy";

  }
  onImageLoad() {
    this.isLoading = false;
  }
  close() {
    if (!this.showPopup) {
      return;
    }

    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.copyLabel = "Copy";
    this.showPopup = false;

  }

  redirectToSettings() {
    this._router.navigateByUrl('/registry/settings')
    this.close();
  }

  loadQrCode() {

    let canvas: any = document.getElementById('canvas');
    const qrCode = this.generateQrCode();

    canvas.innerHTML = '';
    qrCode.append(canvas);
  }

  private generateQrCode() {
    return new (window as any).QRCodeStyling(



      {
        "type": "canvas", "shape": "square", "width": 300, "height": 300,  data: "https://www.hitchd.com/" + this.registry.registryName, "margin": 2, "qrOptions": { "typeNumber": "0", "mode": "Byte", "errorCorrectionLevel": "Q" }, "imageOptions": { "saveAsBlob": true, "hideBackgroundDots": true, "imageSize": 1, "margin": 4 }, "dotsOptions": { "type": "square", "color": "#000000", "roundSize": true }, "backgroundOptions": { "round": 0, "color": "#ffffff" },
        //  image: "/marketing/images/hitchd-logo-qr.png",
        "dotsOptionsHelper": { "colorType": { "single": true, "gradient": false }, "gradient": { "linear": true, "radial": false, "color1": "#6a1a4c", "color2": "#6a1a4c", "rotation": "0" } }, "cornersSquareOptions": { "type": "square", "color": "#000000" }, "cornersSquareOptionsHelper": { "colorType": { "single": true, "gradient": false }, "gradient": { "linear": true, "radial": false, "color1": "#000000", "color2": "#000000", "rotation": "0" } }, "cornersDotOptions": { "type": "square", "color": "#000000" }, "cornersDotOptionsHelper": { "colorType": { "single": true, "gradient": false }, "gradient": { "linear": true, "radial": false, "color1": "#000000", "color2": "#000000", "rotation": "0" } }, "backgroundOptionsHelper": { "colorType": { "single": true, "gradient": false }, "gradient": { "linear": true, "radial": false, "color1": "#ffffff", "color2": "#ffffff", "rotation": "0" } }
      }
    );
  }

  downloadQrCode() {
    this._analyticsService.trackEvent('Website QR Code Downloaded', {});
    let canvas: any = document.querySelector("canvas");
    const canvasElement = canvas;
    if (canvasElement) {
      const dataURL = canvasElement.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'qr-code.png';
      link.click();
    }

  }
  ngOnInit() {




    this._registryService.setScrollY(1);

    this._websiteStateStore.getState().takeUntil(this.ngUnsubscribe).subscribe(state => {
      if (state && state.website) {
        this.website = state.website;
      }

    })

    this.gifts = this.route.snapshot.data.gifts;
    if(this.registry && this.registry.id){
    this._registryFirebaseService.getGiftsforRegistry(this.registry.id).take(1).subscribe(gifts => {
      this.gifts = gifts;
    })
  }
    this._registryService.showGenericPopup$.subscribe(popupType => {

      if (popupType == "share") {
        this.showPopup = true;
        //get gifts for registry but take 1 evry time we set this to show 
        this._registryFirebaseService.getGiftsforRegistry(this.registry.id).take(1).subscribe(gifts => {
          this.gifts = gifts;
        })
        
        this.loadQrCode();
        this.copyLabel = "Copy";
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
      } else {
        this.close();
      }

    });

  }

  loadForm() {
    this._registryFirebaseService.currentRegistry.takeUntil(this.ngUnsubscribe).subscribe(registry => {
      this.qrImageSrc = null;
      if (registry) {
        this.registry = registry;
        this.qrImageSrc = `https://api.qrserver.com/v1/create-qr-code/?data=hitchd.com/${registry.registryName}&amp;size=100x100`
        this.isLive = registry.isLive;
        this._registryFirebaseService.currentSettings.takeUntil(this.ngUnsubscribe).subscribe(settings => {
          this.settings = settings;
          this.isLoaded = true;
          this._registryFirebaseService.killLoader();
          if (settings && settings.payoutsEnabled !== true) {
            this.payoutsEnabled = settings.payoutsEnabled;
          }
          if (this.payoutsEnabled === undefined && this.settings && this.settings.stripeAccountId) {
          }
        });
      }
    });
  }



  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  getCountry(country: string) {
    switch (country) {
      case 'AU': {
        return 'Australia';
      }
      case 'GB': {
        return 'UK';
      }
      case 'US': {
        return 'United States';
      }
      case 'NZ': {
        return 'New Zealand';
      }
      case 'JP': {
        return 'Japan';
      }
      case 'CA': {
        return 'Canada';
      }
    }
  }

  setupStripe(): Promise<any> {
    const country = this.registry.country;
    const currency = this.registry.currency;
    const registryName = this.registry.registryName;
    const email = encodeURI(this.user.email.replace(/[\n\t\r]/g, ''));
    //
    //   + 'country=' + country
    //   + '&currency=' + currency
    //   + '&registryName=' + registryName
    //   + '&email=' + email.trim()

    return this._http
      .post(environment.firebase.clouldFunctionHost + '/createStripeAccount', {
        country: country,
        currency: currency,
        registryName: registryName,
        email: email
      })
      .toPromise()
      .catch((e: any) => {
        if (
          e.type === 'StripeInvalidRequestError' &&
          e.code === 'account_already_exists'
        ) {
        }
        this.dupeStripeAccount = true;
        this.processing = false;
      })
      .then((response: any) => {
        const stripeResponse: any = response.json();
        // stripe

        this._registryService.sendFbTrackEvent('Stripe connected');
        this._analyticsService.trackEvent('stripeConnected', {
          registryUrl: 'https://www.hitchd.com/' + registryName
        });

        this._analyticsService.trackEvent('registryStatus', {
          isLive: this.registry.isLive
        });

        this._analyticsService.update(
          {
            stripeConnected: true,
            isLive: true,
            registryUrl: 'https://www.hitchd.com/' + registryName
          }
        );

        const accountId = stripeResponse.id;
        const publicKey = stripeResponse.keys.publishable;

        this.settings.stripeAccountId = accountId;
        this.settings.stripePublicKey = publicKey;
        return this._registryFirebaseService.saveSettings(this.settings);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  savePassword() {
    this._analyticsService.trackEvent('Website/Registry Password Saved', {});
    this._registryFirebaseService.saveRegistry(this.registry);
    this.passwordChanged = false;
  }
  removePassword() {
    this.registry.password = null;
    this._analyticsService.trackEvent('Website/Registry Password Removed', {});
    this._registryFirebaseService.saveRegistry(this.registry);
    this.showPassword = false;
  }
  sendAdwordConversion() {

    const gtag = window['gtag'];
    if (!gtag) {
      return;
    }

    gtag('event', 'conversion', {
      'send_to': 'AW-784025651/A1_qCJKMrKABELOQ7fUC',
      'signup': true,
      'published': true
    });
  }


  updateRegistryLiveStatus(isLive: boolean) {
    this.processing = true;
    if (!this.settings.stripeAccountId) {
      this.setupStripe().then(x => {
        this.processing = false;
        this.registry.isLive = isLive;

        this._registryService.sendFbTrackEvent('Registry published');
        //   this._analyticsService.heap('Stripe Connected');
        this._registryFirebaseService.saveRegistry(this.registry);

      });
    } else {
      if (isLive) {
        setTimeout(() => {
          this.registry.isLive = isLive;
          this._registryFirebaseService.saveRegistry(this.registry);
          this.processing = false;
          this.isLive = isLive;
        }, 1 * 1000);

        this.sendAdwordConversion();
      } else {
        this.registry.isLive = isLive;
        this._registryFirebaseService.saveRegistry(this.registry);
        this.processing = false;
        this.isLive = isLive;
      }
      this._analyticsService.update({ isLive: isLive });
    }

    if (isLive) {
      localStorage.setItem('toast_' + ToastType.share, 'true');
    }
  }

  copy() {
    this.setClipboardText('www.hitchd.com/' + this.registry.registryName);
    this.copyLabel = "Copied";
  }

  navigateToVisilibityPageThenCloseModal() {
    this._router.navigateByUrl('/visibility')
    this.close();
  }
  setClipboardText(text) {
    const id = 'mycustom-clipboard-textarea-hidden-id';
    let existsTextarea: any = document.getElementById(id);

    if (!existsTextarea) {
      const textarea: any = document.createElement('textarea');
      textarea.id = id;
      // Place in top-left corner of screen regardless of scroll position.
      textarea.style.position = 'fixed';
      textarea.style.top = 0;
      textarea.style.left = '-10px';

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textarea.style.width = '1px';
      textarea.style.height = '1px';

      // We don't need padding, reducing the size if it does flash render.
      textarea.style.padding = 0;

      // Clean up any borders.
      textarea.style.border = 'none';
      textarea.style.outline = 'none';
      textarea.style.boxShadow = 'none';

      // Avoid flash of white box if rendered for any reason.
      textarea.style.background = 'transparent';
      document.querySelector('body').appendChild(textarea);

      existsTextarea = document.getElementById(id);
    } else {
    }

    existsTextarea.value = text;
    existsTextarea.select();

    try {
      const status = document.execCommand('copy');

      if (!status) {
      } else {
        this.coppied = true;

        setTimeout(() => {
          this.coppied = false;
        }, 2 * 1000);
      }
    } catch (err) { }
  }
}



// WEBPACK FOOTER //
// ./src/app/account-share/account-share.component.ts